// extracted by mini-css-extract-plugin
export default {"root":"Z3OGeEz6","errorContainer":"w552a10f","errorCode":"O5F7tcsm","errorMessage":"VmSgLVGQ","errorRobot":"XQMu6JBR","errorBackground":"a4yFx2up","errorGround":"BfEKApit"};